import { FC, useCallback } from "react";

import { Avatar, Button, DesignToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { RoleTag } from "components/role-tag/RoleTag";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { ILiveChatAgent } from "store/views/agents";
import { withVar } from "themes/helpers";

import { ColumnWidths } from "./styled";

interface IProps extends IWithBreakpointsProps {
  agent: ILiveChatAgent;
  canImportLiveChatAgents: boolean;
  onImportClick(agentEmail: string): void;
}

const LiveChatAgentRow: FC<IProps> = ({ agent, isMobile, canImportLiveChatAgents, onImportClick }) => {
  const handleImportClick = useCallback(() => {
    onImportClick(agent.email);
  }, [agent.email, onImportClick]);

  return (
    <tr>
      <td style={{ width: ColumnWidths.Avatar }}>
        <div className="selected-mark" />
        <Flex justifyContent="center">
          <Avatar
            type={agent.avatar ? "image" : "text"}
            src={agent.avatar ? agent.avatar : undefined}
            text={agent.name ?? agent.email}
            size="large"
          />
        </Flex>
      </td>
      <td>
        <Text customColor={withVar(DesignToken.ContentBasicPrimary)}>{agent.name || agent.email}</Text>
        <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
          {agent.email}
        </Text>
      </td>
      <td style={{ width: ColumnWidths.LiveChatRole }}>
        <RoleTag role={agent.permission} />
      </td>
      {!isMobile && (
        <td style={{ width: ColumnWidths.Actions }}>
          <Button size="compact" kind="secondary" disabled={!canImportLiveChatAgents} onClick={handleImportClick}>
            Invite
          </Button>
        </td>
      )}
    </tr>
  );
};

export default withBreakpoints(LiveChatAgentRow);
